


























import click2Top from "@/common/directives/click2Top";
import { Vue, Component, Watch } from "vue-property-decorator";
import QNav from "./qNav.vue";
import { namespace } from "vuex-class";

const authStore = namespace("Auth");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const logo = require("@/assets/images/logo.svg");

@Component({
  name: "AdminLayout",
  directives: {
    click2Top,
  },
  components: {
    QNav,
  },
})
export default class AdminLayout extends Vue {
  @authStore.Getter
  public getRole!: string;

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newValue: any, oldValue: any) {
    if (newValue && oldValue && newValue.name !== oldValue.name) {
      this.changedRoute++;
    }
    // this.checkRole();
  }

  mounted() {
    // this.checkRole();
    console.log("admin layout");
  }

  public changedRoute = 1;

  get logo() {
    return logo;
  }

  get titlePage(): string {
    return this.$route.meta.title || "";
  }
  get subTitle(): string {
    return this.$route.meta.subTitle || "";
  }

  public closeNavigate() {
    (this.$refs.top as Element).classList.remove("open");
  }

  get classPage(): string[] {
    this.changedRoute; // hack to re-computed
    const initalClass = ["mb__admin"];
    if (this.$router.currentRoute.meta.className) {
      initalClass.push(this.$router.currentRoute.meta.className);
    }
    return initalClass;
  }
}
